import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MoveTileDigestToProofButton from './MoveTileDigestToProofButton.jsx';
import PopdownButton from './PopdownButton.jsx';
import TileDigestPopDownMenu from './TileDigestPopDownMenu.jsx';

export const Buttons = styled.div`
  position: relative;
  padding: 0;
  display: flex;
`;

const TileDigestButtons = ({
  bucket,
  bucketDate,
  hasIncompleteTiles,
  tileCount,
  hasActiveFilters,
}) => (
  <Buttons data-single-tile-digest={bucketDate.toString()}>
    <MoveTileDigestToProofButton
      bucket={bucket}
      bucketDate={bucketDate}
      hasIncompleteTiles={hasIncompleteTiles}
      tileCount={tileCount}
      hasFilters={hasActiveFilters}
    />
    <div>
      <PopdownButton key="pill" bucketDate={bucketDate} />
    </div>
    <div className="popdown-menu new-popdown-menu">
      <TileDigestPopDownMenu bucketDate={bucketDate} />
    </div>
  </Buttons>
);

TileDigestButtons.propTypes = {
  bucket: PropTypes.array,
  bucketDate: PropTypes.string.isRequired,
  hasIncompleteTiles: PropTypes.bool.isRequired,
  tileCount: PropTypes.number,
  hasActiveFilters: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { tiles } = state.tiles.tiles.plan;
  const bucket = tiles.filter(tile => tile.planDate === ownProps.bucketDate);
  const hasIncompleteTiles = bucket.some(tile => !tile.fullyAssembled);
  const tileCount = bucket.length;
  const { tileStatusNav, activeStatus } = state.status;
  const topicsFilter = tileStatusNav[activeStatus].filter['ribbonTag']
    ? true
    : false;
  const audiencesFilter = tileStatusNav[activeStatus].filter['audience']
    ? true
    : false;
  const hasActiveFilters = topicsFilter || audiencesFilter;

  return {
    bucket,
    hasIncompleteTiles,
    tileCount,
    hasActiveFilters,
  };
};

export { TileDigestButtons };

export default connect(mapStateToProps)(TileDigestButtons);
